import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Settings from '../../assets/mainControls/IconSettings.svg?react';
import Session from '../../assets/mainControls/IconSession.svg?react';
import { VideoContentPanelStyle } from './style';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const SESSION_TAB = 'Sessielog';
const TASK_TAB = 'Taakcomponenten';

interface TabOptionsToogleProps<T extends ToogleOptions> {
  onChangeHandler: Function;
  isActive: string;
}

interface ToogleOptions {
  content: string;
  isActive: boolean;
  startIcon?: React.ReactNode;
  type: 'text';
}

export default function TabOptionsToogle<T extends ToogleOptions>(props: TabOptionsToogleProps<T>) {
  const { isActive, onChangeHandler } = props;
  const { t } = useTranslation();
  const [value, setValue] = React.useState(isActive === TASK_TAB ? 0 : 1);
  const { videoTabContainer } = VideoContentPanelStyle;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onChangeHandler(newValue === 0 ? TASK_TAB : SESSION_TAB);
  };

  return (
    <Box sx={videoTabContainer}>
      <Box className="tabs-container">
        <Tabs className="tabs" value={value} onChange={handleChange} aria-label="tab options toggle">
          <Tab
            className={`tab`}
            label={t(TASK_TAB)}
            icon={<Settings className="icon" />}
            iconPosition="start"
            {...a11yProps(0)}
            disableRipple={true}
          />
          <Tab
            className={`tab`}
            label={t(SESSION_TAB)}
            icon={<Session className="icon" />}
            iconPosition="start"
            {...a11yProps(1)}
            disableRipple={true}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}></CustomTabPanel>
      <CustomTabPanel value={value} index={1}></CustomTabPanel>
    </Box>
  );
}
